var _path, _ellipse;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-inline--fa fa-fw",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.33333C8 7.83888 8.14662 7.35553 8.42133 6.94441C8.69603 6.53329 9.08648 6.21285 9.54329 6.02364C10.0001 5.83442 10.5028 5.78491 10.9877 5.88137C11.4727 5.97783 11.9181 6.21594 12.2678 6.56557C12.6174 6.9152 12.8555 7.36066 12.952 7.84561C13.0484 8.33056 12.9989 8.83323 12.8097 9.29004C12.6205 9.74686 12.3 10.1373 11.8889 10.412C11.4778 10.6867 10.9945 10.8333 10.5 10.8333V11.6667M18 10C18 14.1421 14.6421 17.5 10.5 17.5C6.35786 17.5 3 14.1421 3 10C3 5.85786 6.35786 2.5 10.5 2.5C14.6421 2.5 18 5.85786 18 10Z",
    stroke: "currentColor",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5,
    cy: 14.1667,
    rx: 0.833333,
    ry: 0.833333,
    fill: "currentColor",
    fillOpacity: 0.7
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default "data:image/svg+xml;base64,PHN2ZyBjbGFzc05hbWU9InN2Zy1pbmxpbmUtLWZhIGZhLWZ3IiB2aWV3Qm94PSIwIDAgMjEgMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik04IDguMzMzMzNDOCA3LjgzODg4IDguMTQ2NjIgNy4zNTU1MyA4LjQyMTMzIDYuOTQ0NDFDOC42OTYwMyA2LjUzMzI5IDkuMDg2NDggNi4yMTI4NSA5LjU0MzI5IDYuMDIzNjRDMTAuMDAwMSA1LjgzNDQyIDEwLjUwMjggNS43ODQ5MSAxMC45ODc3IDUuODgxMzdDMTEuNDcyNyA1Ljk3NzgzIDExLjkxODEgNi4yMTU5NCAxMi4yNjc4IDYuNTY1NTdDMTIuNjE3NCA2LjkxNTIgMTIuODU1NSA3LjM2MDY2IDEyLjk1MiA3Ljg0NTYxQzEzLjA0ODQgOC4zMzA1NiAxMi45OTg5IDguODMzMjMgMTIuODA5NyA5LjI5MDA0QzEyLjYyMDUgOS43NDY4NiAxMi4zIDEwLjEzNzMgMTEuODg4OSAxMC40MTJDMTEuNDc3OCAxMC42ODY3IDEwLjk5NDUgMTAuODMzMyAxMC41IDEwLjgzMzNWMTEuNjY2N00xOCAxMEMxOCAxNC4xNDIxIDE0LjY0MjEgMTcuNSAxMC41IDE3LjVDNi4zNTc4NiAxNy41IDMgMTQuMTQyMSAzIDEwQzMgNS44NTc4NiA2LjM1Nzg2IDIuNSAxMC41IDIuNUMxNC42NDIxIDIuNSAxOCA1Ljg1Nzg2IDE4IDEwWiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1vcGFjaXR5PSIwLjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8ZWxsaXBzZSBjeD0iMTAuNSIgY3k9IjE0LjE2NjciIHJ4PSIwLjgzMzMzMyIgcnk9IjAuODMzMzMzIiBmaWxsPSJjdXJyZW50Q29sb3IiIGZpbGwtb3BhY2l0eT0iMC43Ii8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };